export default __webpack_public_path__ + "static/media/Graphics_letterpad-01-min.d647a4f3.jpg";